// extracted by mini-css-extract-plugin
module.exports = {"Boxes":"Boxes_Boxes__kgjcX","BoxWrapper":"Boxes_BoxWrapper__2y_mu","Box":"Boxes_Box__2dJYH","Title":"Boxes_Title__2qcfr","Text":"Boxes_Text__1d8cX","Link":"Boxes_Link__3xbuF"};